import ModalSelectWithLabel from "@/components/form/hook-form/modal-select-with-label";
import { useViewportHeight } from "@/hooks/utils/use-viewport-height";
import { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { SexSelectModal } from "./sex-select-modal";

type SexModalSelectProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  error?: string;
  theme?: "light" | "settings";
};

const sexOptions = [
  { value: "male", name: "Male" },
  { value: "female", name: "Female" },
];

export const SexModalSelect = <T extends FieldValues>({
  form,
  name,
  error,
  theme = "light",
}: SexModalSelectProps<T>) => {
  const viewportHeight = useViewportHeight();
  return (
    <ModalSelectWithLabel
      control={form.control}
      name={name}
      label="Sex at birth"
      placeholder="Choose..."
      options={sexOptions}
      error={error}
      theme={theme}
      initialBreakpoint={378 / viewportHeight}
      renderModalContent={({ onSelect }) => (
        <SexSelectModal
          defaultValue={form.getValues(name)}
          options={sexOptions}
          onSelect={onSelect}
        />
      )}
    />
  );
};

export default SexModalSelect;
